import daytimeAdviceApi from "../../../api/daytime_advices";
import sessionApi from "../../../api/session";

type SearchCondition = {
  date: string | null;
  status: number | null;
  doctorFamilyName: string | null;
  doctorFirstName: string | null;
};

type SearchSheet = Record<string, unknown>;

type SearchSheetsResult = {
  sheets: SearchSheet[];
  totalCount: number;
  count: number;
};

type SearchSheetsApiResponse = {
  data?: SearchSheet[];
  totalCount?: number;
  count?: number;
};

type SearchStatus = {
  key: string;
  value: number | null;
};

type CurrentDoctor = {
  type?: string;
} & Record<string, unknown>;

type SearchResetState = {
  condition: SearchCondition;
  sheets: SearchSheet[];
  totalCount: number;
  count: number;
};

type SearchActions = {
  fetchStatuses(): Promise<SearchStatus[]>;
  fetchCurrentDoctor(): Promise<CurrentDoctor | null>;
  updateCondition<K extends keyof SearchCondition>(
    condition: SearchCondition,
    field: K,
    value: SearchCondition[K]
  ): SearchCondition;
  search(condition: SearchCondition): Promise<SearchSheetsResult>;
  reset(): SearchResetState;
};

const defaultCondition = (): SearchCondition => ({
  date: null,
  status: null,
  doctorFamilyName: null,
  doctorFirstName: null
});

const searchSheets = (condition: SearchCondition): Promise<SearchSheetsResult> => {
  return new Promise((resolve) => {
    daytimeAdviceApi.searchSheets((response: SearchSheetsApiResponse) => {
      const sheets = response?.data ?? [];
      resolve({
        sheets,
        totalCount: response?.totalCount ?? sheets.length,
        count: response?.count ?? sheets.length
      });
    }, condition);
  });
};

export const createSearchActions = (): SearchActions => ({
  fetchStatuses() {
    return new Promise((resolve) => {
      daytimeAdviceApi.fetchDaytimeAdviceSheetStatuses((statuses: SearchStatus[] | null | undefined) => {
        resolve(statuses ?? []);
      });
    });
  },
  fetchCurrentDoctor() {
    return new Promise((resolve) => {
      sessionApi.fetchCurrentDoctor((doctor: CurrentDoctor | null | undefined) => {
        resolve(doctor ?? null);
      });
    });
  },
  updateCondition(condition, field, value) {
    return {
      ...condition,
      [field]: value
    };
  },
  search(condition) {
    return searchSheets(condition);
  },
  reset() {
    return {
      condition: defaultCondition(),
      sheets: [],
      totalCount: 0,
      count: 0
    };
  }
});
